@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.label-que-wrapper {
  position: absolute;
  right: 25px;
  top: 40px;
  height: calc(100% - 40px);
  z-index: 3;
  width: 405px;
  transition: all 600ms ease;
  background-color: @label-que--wrapper--background-color;
  box-shadow: 0 0 5px 3px @label-que--wrapper--box-shadow-color;
  &.closed {
    height: 0;
    display: none;
  }
}

.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.header-label {
  width: 100%;
  font-size: 18px;
  padding: 20px 10px 5px;
}

.header-link {
  font-size: 13px;
  padding: 20px 0 0 10px;
}

.toggle-que {
  cursor: pointer;
  > svg {
    padding: 9px;
  }
  &:hover {
    > svg {
      fill: @label-que--toggle--hover--fill-color;
    }
  }
}
